//
//
//
//

import { paypalPay } from "../../services/payment";
import {
  BEFORE_PAY_PAGE,
  CURRENT_PUBLISHER_SIMPLE,
  DEVICE,
  PAY_PAGE_TYPE,
  PAY_PAGE_TYPE_ID,
  PAYPAL_INFO,
} from "../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
  name: "PaymentSuccessPage",
  computed: {
    ...mapGetters({
      currentLinkedInstagram: CURRENT_PUBLISHER_SIMPLE,
      device: DEVICE,
    }),
  },
  data() {
    return {
      showError: true, // 是否展示错误信息
    };
  },
  async activated() {
    // 点击支付清空paypal info 信息
    this.$store.commit(PAYPAL_INFO, null);
    // 直接跳转到订阅页面(并告知来源用以重写back行为)
    const typeName = this.$store.getters[PAY_PAGE_TYPE];
    const typeId = this.$store.getters[PAY_PAGE_TYPE_ID];
    const { token, paymentId, PayerID } = this.$route.query;
    console.log("paypal 成功回调参数", this.$route.query);
    try {
      if (typeName) {
        this.$router.replace({
          name: "PaymentSubscriptionPage",
          params: { name: typeName },
          query: { source: "pay", id: typeId },
        });
      }
      this.$parent.$data.showPayLoading = true;
      await paypalPay({ token, paymentId, PayerID });
      // 支付成功后判断
      const beforePaySuccessPage = this.$store.getters[BEFORE_PAY_PAGE];
      if (this.device === "android") {
        // eslint-disable-next-line
        AndroidWebView.closeWebView(1); // 0 为未进行任何操作
      }
      if (
        beforePaySuccessPage === "PaymentUpgradePage" ||
        beforePaySuccessPage === "MyPlanPage"
      ) {
        this.$router.replace({ name: "MyPlanPage" });
      } else if (beforePaySuccessPage === "ActivePage") {
        // 激活后同时尝试激活当前publisher的所有post
        await this.currentLinkedInstagram.postActive();
        this.$router.replace({ name: "ActivePage" });
      } else {
        this.$router.replace({ name: "MyPlanPage" });
        console.error("跳转页面判断错误" + beforePaySuccessPage);
      }
      this.$toast.show({ message: this.$t("common.success") });
    } catch (e) {
      this.$parent.$refs.payError.show({ params: { id: typeId, sale: true } });
    } finally {
      this.$parent.$data.showPayLoading = false;
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/payment/Success.vue